import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MasterPayrollObject, Payline, PaylineType } from '../../../../models/payroll';
import { BasePayrollComponent } from '../../../../components/base/base-payroll.component';

export class HistoryVoidSelection {
  PayDate: string;
  Payroll: MasterPayrollObject;
  Payline: Payline;
}

@Component({
  selector: 'lib-history-void-selection',
  templateUrl: './history-void-selection.component.html',
  standalone: false
})
export class HistoryVoidSelectionComponent extends BasePayrollComponent implements OnInit {
  @Output() handleBack = new EventEmitter();
  @Output() handleContinue: EventEmitter<HistoryVoidSelection> = new EventEmitter();
  @Input() payrolls: MasterPayrollObject[] = [];
  @Input() personName: string;

  public selPayroll: HistoryVoidSelection;
  public selections: HistoryVoidSelection[] = [];

  ngOnInit(): void {
    if (this.payrolls.length) {
      // expect a single employee pay object
      // if they have multiple paylines in a payroll, show multiple options
      for (let payroll of this.payrolls) {
        for (let payline of payroll.EmployeePays[0].Paylines) {
          payline.PaylineType == PaylineType.Void;
          const sel = new HistoryVoidSelection();
          sel.Payroll = payroll;
          sel.Payline = payline;

          const d = new Date(payroll.PayDate);
          const month = (d.getMonth() + 1).toString().padStart(2, '0');
          const day = d.getDate().toString().padStart(2, '0');

          sel.PayDate = `${month}/${day}/${d.getFullYear()}`;

          this.selections.push(sel);
        }
      }
    }
  }

  public onBack() {
    this.handleBack.emit();
  }

  public onContinue() {
    this.handleContinue.emit(this.selPayroll);
  }
}
